import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/homes/Home';
import Signup from './pages/auth/signup';
import Login from './pages/auth/login';
import './index.css';
import CurtainAnimation from './components/Animation/CurtainAnimation';
import { useEffect, useState } from 'react';
import CoursesList from './pages/courses/CoursesList/CoursesList';
import CoursesSingle from './pages/courses/CoursesSingle/CoursesSingle';
import AboutUs from './pages/aboutus/Aboutus';
import BlogList from './pages/blogs/bloglist/BlogList';
import BlogSingle from './pages/blogs/blogsingle/BlogSingle';
import Contact from './pages/contact/Contact';
import EventList from './pages/events/eventList/EventList';
import EventSingle from './pages/events/eventSingle/EventSingle';
import InstructorsList from './pages/instructors/instructorList/InstructorsList';
import InstructorsSingle from './pages/instructors/instructorSingle/InstructorsSingle';
import Error404 from './pages/errors/Error404';
import LessonPage from './pages/lessons/LessonPage';
import BecomeInstructor from './pages/instructors/becomeInstructors/BecomeInstructor';
import Faqs from './pages/faqs/Faqs';
import HomeBootcamp from './pages/homeBootcamp/HomeBootcamp';
import HomeLittleMaker from './pages/homeLittleMaker/HomeLittleMaker';
import HomeTutorat from './pages/homeTutorat/HomeTutorat';
import NextMakerMethod from './pages/NextMaker Method/NextMakerMethod';
import SchoolOffer from './pages/School Offer/SchoolOffer';
import SummerMakerStages from './pages/Summer Maker Stages/SummerMakerStages';
import Community from './pages/Communauté/Community';
import LegalNotice from './pages/legal notice/LegalNotice';
import HelpCenter from './pages/helpCenter/HelpCenter';
import CookiePage from './pages/cookiePolicy/CookiePage';
import Blog from './pages/blogs/blog/Blog';
import SearchPage from './pages/search/SearchPage';
import PrivateRoute from './components/AuthRoute/PrivateRoute';

function App() {
  const [showCurtain, setShowCurtain] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowCurtain(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <BrowserRouter>
      {showCurtain && <CurtainAnimation />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/bootcamp" element={<HomeBootcamp />} />
        <Route path="/little-maker" element={<HomeLittleMaker />} />
        <Route path="/tutorat" element={<HomeTutorat />} />
        <Route path="/next-maker-method" element={<NextMakerMethod />} />
        <Route path="/school-offer" element={<SchoolOffer />} />
        <Route path="/summer-maker-stages" element={<SummerMakerStages />} />
        <Route path="/community" element={<Community />} />
        <Route path="/legal-notice" element={<LegalNotice />} />
        <Route path="/help-center" element={<HelpCenter />} />
        <Route path="/cookie-policy" element={<CookiePage />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/auth/register" element={<Signup />} />
        <Route path="/auth/login" element={<Login />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="*" element={<Error404 />} />
        <Route path="/courses-list" element={<CoursesList />} />
        <Route path="/courses-single/:id" element={<CoursesSingle />} />


        <Route path="/blog-list"
          element={
            <PrivateRoute>
              <BlogList />
            </PrivateRoute>
          }
        />

        <Route path="/blog-single"
          element={
            <PrivateRoute>
              <BlogSingle />
            </PrivateRoute>
          }
        />

        <Route path="/event-list"
          element={
            <PrivateRoute>
              <EventList />
            </PrivateRoute>
          }
        />

        <Route path="/event-single"
          element={
            <PrivateRoute>
              <EventSingle />
            </PrivateRoute>
          }
        />

        <Route path='/instructors-list'
          element={
            <PrivateRoute>
              <InstructorsList />
            </PrivateRoute>
          }
        />

        <Route path='/instructors-single/:id'
          element={
            <PrivateRoute>
              <InstructorsSingle />
            </PrivateRoute>
          }
        />

        <Route path='/lesson-page/:courseId/:modId/:id'
          element={
            <PrivateRoute>
              <LessonPage />
            </PrivateRoute>
          }
        />

        <Route path='/become-an-instructor'
          element={
            <PrivateRoute>
              <BecomeInstructor />
            </PrivateRoute>
          }
        />

        <Route path='/faqs'
          element={
            <PrivateRoute>
              <Faqs />
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
